/**
 * Shown in place of the console to a signed-in volunteer who is not a
 * `commune_admin` of the commune in the URL (`docs/ADMIN.md` §1) — never a
 * redirect, so a bookmarked or typed console link always lands somewhere
 * that explains why, not on an empty console or a silent bounce home.
 */
import { Link } from 'react-router-dom';

import { Card } from '../../../components/ui';
import { t } from '../../../i18n/fr';

/**
 * Render the refusal screen.
 *
 * @returns The page element.
 */
export function AdminRefusalPage() {
  return (
    <div className="auth-screen">
      <Card>
        <h1>{t('admin.refusal.title')}</h1>
        <p>{t('admin.refusal.body')}</p>
        <Link to="/" className="ui-btn ui-btn--primary ui-btn--full">
          {t('admin.refusal.backHome')}
        </Link>
      </Card>
    </div>
  );
}
